export const responsivnessPlugin = {
    install(Vue) {
      Vue.prototype.$isMobile = function () {
        return screen.width <= 600;
      };
    },
  };
  